// extracted by mini-css-extract-plugin
export var active = "annual-events-module--active--86d41";
export var annualEvents = "annual-events-module--annual-events--b9914";
export var annualNews = "annual-events-module--annual-news--efcf7";
export var annualProjects = "annual-events-module--annual-projects--02804";
export var backgroundImage = "annual-events-module--background-image--21c00";
export var btnClose = "annual-events-module--btn-close--c7721";
export var btnOutlineLsuGold = "annual-events-module--btn-outline-lsu-gold--d0fda";
export var btnOutlineLsuPurple = "annual-events-module--btn-outline-lsu-purple--113e0";
export var btnPrimary = "annual-events-module--btn-primary--d807f";
export var btnSecondary = "annual-events-module--btn-secondary--7f67f";
export var cardHover = "annual-events-module--card-hover--a2f72";
export var eventBlog = "annual-events-module--event-blog--30bcb";
export var h1 = "annual-events-module--h1--d0550";
export var h2 = "annual-events-module--h2--1cbdc";
export var h3 = "annual-events-module--h3--1ba1a";
export var h4 = "annual-events-module--h4--521f5";
export var h5 = "annual-events-module--h5--c3272";
export var h6 = "annual-events-module--h6--d1b09";
export var hover = "annual-events-module--hover--fc9c1";
export var menu = "annual-events-module--menu--69d5d";
export var navLink = "annual-events-module--nav-link--05ce6";
export var navbarDark = "annual-events-module--navbar-dark--bc1af";
export var navbarNav = "annual-events-module--navbar-nav--22009";
export var navbarToggler = "annual-events-module--navbar-toggler--29e76";
export var navbarTogglerIcon = "annual-events-module--navbar-toggler-icon--1ea28";
export var newsArticle = "annual-events-module--news-article--b2e3b";
export var newsEventsEvents = "annual-events-module--news-events-events--fed88";
export var newsEventsNews = "annual-events-module--news-events-news--8dafe";
export var pageItem = "annual-events-module--page-item--c204b";
export var pageLink = "annual-events-module--page-link--26ef7";
export var projectPost = "annual-events-module--project-post--1c862";
export var textLight = "annual-events-module--text-light--4e4cd";
export var textLsuLightGold = "annual-events-module--text-lsu-light-gold--f11f0";
export var textWhite = "annual-events-module--text-white--e95db";
export var topNavigation = "annual-events-module--top-navigation--e636f";
export var underline = "annual-events-module--underline--6987a";